<template>
  <div
    class="bookmark-nav relative flex h-full shrink-0"
    :class="side === 'left' ? 'bookmark-nav--left flex-row-reverse' : 'bookmark-nav--right flex-row'"
  >
    <!-- 書籤列表（桌機） -->
    <div class="bookmark-nav__inner absolute top-0 bottom-0 w-40 hidden xl:flex flex-col gap-[1.6rem] pt-[1.6rem] overflow-visible"
         :class="side === 'left' ? 'right-0' : 'left-0'">
      <button
        v-for="(page, i) in computedPages"
        :key="page.route"
        class="bookmark-nav__tab w-40 h-[3.2rem] bg-[#1e1e1e] border-none cursor-pointer flex items-center relative shrink-0 transition-[background,transform] duration-[0.18s]"
        :class="{
          'bookmark-nav__tab--current': page.isCurrent,
          'bookmark-nav--left__tab': side === 'left',
        }"
        :style="{ '--tab-index': i }"
        :disabled="page.isCurrent"
        @click="!page.isCurrent && $emit('navigate', page.route)"
      >
        <span
          class="text-[0.85rem] font-bold tracking-[0.05em] text-[rgba(232,232,232,0.5)] whitespace-nowrap select-none transition-colors duration-[0.18s]"
          :class="side === 'left' ? 'bookmark-nav__label--left' : ''"
        >{{ page.label }}</span>
      </button>
    </div>


    <!-- 書籤凸出區佔位 -->
    <div class="bookmark-nav__spacer w-0 xl:w-40 shrink-0 pointer-events-none"></div>
  </div>
</template>

<script>
import { BOOK_PAGES } from './BookLayout.vue'

export default {
  name: 'BookmarkNav',
  props: {
    side: { type: String, default: 'right' },
  },
  emits: ['navigate', 'menu'],
  computed: {
    currentRoute() {
      return this.$route?.path ?? ''
    },
    currentIndex() {
      const r = this.currentRoute
      if (r.startsWith('/items')) return BOOK_PAGES.findIndex(p => p.name === 'Items')
      if (r.startsWith('/blog'))  return BOOK_PAGES.findIndex(p => p.name === 'Blog')
      return BOOK_PAGES.findIndex(p => p.route === r)
    },
    enrichedPages() {
      const commissionOpen = this.$store.getters.commissionOpen
      return BOOK_PAGES.filter(p => p.name !== 'Commission' || commissionOpen)
    },
    computedPages() {
      const pages = this.enrichedPages
      const i = this.currentIndex
      if (this.side === 'left') {
        const prev = [pages[0], ...pages.slice(1, i)]
        const current = { ...pages[i], isCurrent: true }
        return [...prev, current]
      } else {
        if (i <= 0) return pages.slice(1)
        return pages.slice(i + 1)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
// clip-path 無法用 Tailwind 表達
.bookmark-nav--right { clip-path: inset(0px -9999px 0px 0px); }
.bookmark-nav--left  { clip-path: inset(0px 0px 0px -9999px); }

// 書背薄條（偽元素）
.bookmark-nav::before {
  content: '';
  display: block;
  width: 1.8rem;
  flex-shrink: 0;
  align-self: stretch;
  background:
    repeating-linear-gradient(to right, transparent 0px, transparent 2px, rgba(255,255,255,0.025) 2px, rgba(255,255,255,0.025) 3px),
    linear-gradient(to right, #2a2a2a 0%, #212121 40%, #1a1a1a 100%);
  border-top:    1px solid rgba(255, 255, 255, 0.06);
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
}
.bookmark-nav--right::before { border-right: 1px solid rgba(255, 255, 255, 0.1); }
.bookmark-nav--left::before  { border-left:  1px solid rgba(255, 255, 255, 0.1); }

// 右側書籤：右凸箭頭
.bookmark-nav__tab {
  clip-path: polygon(0% 0%, 100% 0%, calc(100% - 1.1rem) 50%, 100% 100%, 0% 100%);
  padding-left: 0.7rem;
  padding-right: 1.4rem;
  transform: translateX(calc(var(--tab-index, 0) * 0.26rem));

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    clip-path: inherit;
    border-top:    1px solid rgba(255, 255, 255, 0.1);
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
    pointer-events: none;
  }

  &:hover:not(:disabled) {
    background: #2a1215;
    transform: translateX(calc(var(--tab-index, 0) * 0.26rem + 0.25rem));
    span { color: #e8e8e8; }
  }

  &--current {
    background: #181010;
    cursor: default;
    opacity: 0.85;
    &::after {
      content: '';
      position: absolute;
      right: 1.1rem; top: 15%; bottom: 15%; width: 2px;
      background: rgba(195, 14, 35, 0.6);
    }
  }
}

// 左側書籤：燕尾形
.bookmark-nav--left .bookmark-nav__tab {
  clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%, 1.1rem 50%);
  padding-left: 1.6rem;
  padding-right: 0.7rem;
  margin-left: auto;
  transform: translateX(calc(var(--tab-index, 0) * -0.26rem));

  &:hover:not(:disabled) {
    transform: translateX(calc(var(--tab-index, 0) * -0.26rem - 0.25rem));
  }

  &.bookmark-nav__tab--current::after {
    right: auto;
    left: 1.1rem;
  }
}

// 手機漢堡 clip-path（燕尾朝左，箭頭從左側切入）
.bookmark-nav__menu {
  clip-path: polygon(1.1rem 0%, 100% 0%, 100% 100%, 1.1rem 100%, 0% 50%);

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    clip-path: inherit;
    border-top:    1px solid rgba(255, 255, 255, 0.1);
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
    pointer-events: none;
  }
}
</style>
